import { getExpenseLabel } from "web_myplann/Finances/Helpers/getExpenseLabel";
import { isDetailedExpenses } from "web_myplann/Finances/Helpers/isDetailedExpenses";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { BalanceBreakdownEntry } from "web_myplann/Finances/Types/BalanceBreakdownEntry";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const mapExpenseBreakdown = (
	expenses: FinanceState["expenses"],
	t: TranslateFunction,
): BalanceBreakdownEntry[] =>
	isDetailedExpenses(expenses)
		? expenses.map((entry, index) => ({
				key: `${entry.id ?? "new"}-${index}`,
				label: getExpenseLabel(entry, t),
				amount: entry.monthlyPayment,
			}))
		: [];
